var rating_text = {};
var rating_average = 0;
var rating_wrapper = null;

function ratingAverage(rating_wrapper) {
    var $rating_average = rating_wrapper.find('#ratingAverage');

    if ($rating_average.length) {
        $rating_average.empty().text(rating_text['vote.average']);
    } else {
        rating_wrapper.append('<span id="ratingAverage" class="invisible-text" aria-live="polite">' + rating_text['vote.average'] + '</span>');
    }
}

var openModaleRecipeIngredientsAddToCart = function ($modalTrigger, isAddingAll) {

    pushDataLayerRecipeShopIngredient(isAddingAll);

    var containerModale = isAddingAll ? $('#addToCartAllIngredientsModaleContainer') : $modalTrigger.parent().siblings('[id^=addToCartIngredientModaleContainer]') ;
    var modaleIngredients = containerModale.find('.remodal-add-to-cart-ingredient');

        containerModale.find('.slick-initialized').slick('unslick');
        productTileSlick();

    // Open or reopen the modale Add to cart for an ingredient
    var openIngredientModale = function () {
        // Each time the modal is opened we have to sent to analytics the list of products shown
        containerModale.find('.productsIngredientList').each(function () {
            push_product_list_metrics($(this));
        });
    };

    var initSlider = function (containerSlider) {
        var productsSlider = containerSlider.find('.productsIngredientList');
        if (Revealizr.isDesktopSize) {
            $('.see-all-product-tile').remove();
        }

        productsSlider.refreshImages();
        injectSVG();
        updateQtyIncrementerButtonsState();
        showProductsPreviousErrors();

        // Each time we click on See all products link, we sent to analytics the event
        containerSlider.find(".show-all-products").click(function () {
            pushDataLayerRecipeSeeAllProducts(containerModale.find('.ingredientBox').length > 1);
        });
    };

    // Call by ajax hybris to get the list of products addeable to the cart
    var bindIngredientModaleButtonBox = function () {
        $("[id^=button-ingredients-add-to-cart-]").on('click', function () {
            const triggerIngredient = $(this);
            const containerIngredientExpandCollapse = triggerIngredient.closest('.ingredientBox-toggle');
            const containerIngredientCarousel = $(triggerIngredient.data("display-tab"));
            const modaleAddToCartFromIngredient = $('.remodal-add-to-cart-ingredient');

            // Call only if a previous call has not been done before = products-listing exists
            if (containerIngredientCarousel.find(".productsIngredientList").length == 0) {
                TINK.inProgress(modaleAddToCartFromIngredient);
                TINK.sessionAjax({
                    url: addIngredientsToCartAjaxUrl + "/update",
                    data: JSON.stringify({
                        hybrisKeywords: $(this).data("hybris-keywords"),
                        metroShopCategory: $(this).data("metro-shop-category")
                    }),
                    type: 'post',
                    contentType: 'application/json; charset=utf-8',
                    success: function (data) {
						containerIngredientCarousel.append(data);
						triggerIngredient.addClass('is_active');
						containerIngredientExpandCollapse.dishide();
						containerModale.modalActionsExceptions({
							ctaAddToCart : '[onclick*="addProductToCart"]',
							ctaAddToCartStarter : '.addToCartStarter',
							tabClose : '.remodal-add-to-cart-ingredient',
							tabsType : 'modal-ingredients'
						});
                        initSlider(containerIngredientCarousel);
                        productTileSlick();
                        push_product_list_metrics(containerIngredientCarousel);
                        showProductsPreviousErrors();
                    },
                    error: function (jqXHR) {
                        TINK.handleAjaxError(jqXHR);
                    },
                    complete: function () {
                        TINK.stopProgress(modaleAddToCartFromIngredient);
                    }
                });
            }
            // If we expand the ingredient products list we have to send data to google
            else if (!containerIngredientCarousel.hasClass("dishide-target--active")) {
                push_product_list_metrics(containerIngredientCarousel);
            }
        });
	};

    // If the modale is already created we don't call again the backend, just reopen it
    if (modaleIngredients.length > 0 && !$modalTrigger.hasClass('dishide-trigger-is_initialized')) {
        $modalTrigger.addClass('is_active').dishide();
	} else if(modaleIngredients.length > 0) {
        openIngredientModale();
    } else {
        TINK.inProgress($("#Ingredients"));
        // Prepare all informations needed to create the modale of hybris search products
		const ingredientsData = [];
		const $dataHolder = ( isAddingAll ) ? $(".addto-cart-ingredient[data-hybris-keywords != ''][data-hybris-keywords]") : $modalTrigger;

        $dataHolder.each(function () {
            ingredientsData.push({
                name: $(this).data("ingredient-name"),
                measure: $(this).data("measure"),
                hybrisKeywords: $(this).data("hybris-keywords"),
                metroShopCategory: $(this).data("metro-shop-category")
            });
        });

        TINK.sessionAjax({
            url: addIngredientsToCartAjaxUrl,
            data: JSON.stringify(ingredientsData),
            type: 'post',
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
				$modalTrigger.addClass('is_active');
				containerModale.append(data);

				containerModale.modalActionsExceptions({
					ctaAddToCart : '[onclick*="addProductToCart"]',
					ctaAddToCartStarter : '.addToCartStarter',
					tabClose : '.remodal-add-to-cart-ingredient',
					tabsType : 'modal-ingredients'
				});

                if (isAddingAll) {
                    containerModale.find('[data-tab-close]:not(.notification__close)').attr('data-tabs-type', 'modal-ingredients');
                }
				$modalTrigger.dishide();
				containerModale.find('[data-module~="dishide--ajax"]').dishide();
				bindIngredientModaleButtonBox();
                initSlider(containerModale);
                productTileSlick();
                openIngredientModale();
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.log( 'Fix me. I\'m supposed to handle errors' ); //handleError(jqXHR); jira : T4286-3060
                }
            },
            complete: function () {
                TINK.stopProgress($("#Ingredients"));
            }
        });
    }
};

var preventModaleFromClosingAfterAddToCartIfCartExists = function ($modalTrigger, isAddingAll) {
    if (isCartAvailable) {
        var containerModale = isAddingAll ? $('#addToCartAllIngredientsModaleContainer') : $modalTrigger.parent().siblings('[id^=addToCartIngredientModaleContainer]');
        var modaleIngredients = containerModale.find('.remodal-add-to-cart-ingredient');
        if (modaleIngredients.length > 0) {
            modaleIngredients.find('[onclick*="addProductToCart"]').removeAttr('data-tab-close');
        }
    }
};

jQuery(document).ready(function () {

    pushDataLayerRecipeView();

    // Add one ingredient
    $(document).on('click', '.addto-cart-ingredient', function () {
        openModaleRecipeIngredientsAddToCart($(this), false);
        preventModaleFromClosingAfterAddToCartIfCartExists($(this), false);
    });

    // Add all ingredients
    $(document).on('click', '.addto-cart-all-ingredients', function () {
        openModaleRecipeIngredientsAddToCart($(this), true);
        preventModaleFromClosingAfterAddToCartIfCartExists($(this), true);
    });

    $('[data-is="time"]').each(function () {

        var elem = $(this),
            text_original = elem.text().split(':'),
            text_hour = text_original[0],
            text_minute = text_original[1];

        if (lang === 'en') {
            newtext = {
                'recipe.hour': '&nbsp;Hours&nbsp;',
                'recipe.minute': '&nbsp;Minutes&nbsp;'
            };
        } else {
            newtext = {
                'recipe.hour': '&nbsp;heures&nbsp;',
                'recipe.minute': '&nbsp;minutes&nbsp;'
            };
        }
        elem.html(text_hour + '<span aria-hidden="true">:</span><span class="invisible-text">' + newtext['recipe.hour'] + '</span>' + text_minute + '<span class="invisible-text">' + newtext['recipe.minute'] + '</span>');
    });

    $('#starRating').barrating({
        showSelectedRating: true,
        deselectable: true,
        hoverState: true,
        initialRating: ratingNumber,
        readonly: !ratingEnabled,
        onSelect: function (value) {
            $.ajax({
                type: "PUT",
                url: ratingBlockURL + '/' + recipeId + '/' + value,
                success: function () {

                    // Increment the number of votes
                    var $nbRatingVotes = $("#nbRatingVotes");
                    var nbVotes = parseInt($nbRatingVotes.text());

                    rating_average = rating_wrapper.find('.br-current-rating').text();

                    if (!isNaN(nbVotes)) {
                        nbVotes += 1;
                        $nbRatingVotes.text(nbVotes);
                        // Based on previous vote
                        $nbRatingVotes.find("+ span").text(nbVotes === 1 ? ' Vote' : ' Votes');
                    }

                    if (lang === 'en') {
                        rating_text = {
                            'vote.average': 'Vote average : ' + rating_average + ' stars',
                            'vote.star': 'star'
                        };
                    } else {
                        rating_text = {
                            'vote.average': 'Moyenne des votes : ' + rating_average + ' étoiles',
                            'vote.star': 'étoile'
                        };
                    }

                    ratingAverage(rating_wrapper);
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            });

            $('#starRating').barrating('readonly', true);
        },

        onCreate: function () {
            var rating_widget = $(this)[0].$elem.next('.br-widget');
            rating_wrapper = rating_widget.closest('.rh--rating');
            rating_average = rating_wrapper.find('.br-current-rating').text();
            var rating_star_button = rating_widget.find('.br-star');

            if (lang === 'en') {
                rating_text = {
                    'vote.average': 'Vote average : ' + rating_average + ' stars',
                    'vote.star': 'star'
                };
            } else {
                rating_text = {
                    'vote.average': 'Moyenne des votes : ' + rating_average + ' étoiles',
                    'vote.star': 'étoile'
                };
            }

            ratingAverage(rating_wrapper);

            rating_star_button.each(function (index) {
                var title = $(this).attr('title');
                if (index === 0) {
                    $(this).attr({
                        'title': title + ' ' + rating_text['vote.star'],
                        'aria-controls': 'ratingAverage'
                    });
                } else {
                    $(this).attr({
                        'title': title + ' ' + rating_text['vote.star'] + 's',
                        'aria-controls': 'ratingAverage'
                    });
                }
            });
        }
    });
});
